import React, { useState } from 'react';

export default (initVal) => {
    const [loading, setLoading] = useState(initVal || false);
    const bindLoading = {
        show: loading,
        onHide: () => setLoading(false)
    }
    return [setLoading, bindLoading];
}